import Vue from 'vue';
import Vuex from 'vuex';
import store from './store';
import vuexI18n from 'vuex-i18n';
import VueMask from 'v-mask';
import Vuelidate from 'vuelidate';

import productTemplate from './modules/product/product.vue';
import offerteCartTemplate from './modules/offerte/offerteCart.vue';
import offerteCartSentTemplate from './modules/offerte/offerteSent.vue';
import offerteBadgeTemplate from './modules/offerte/offerteBadge.vue';

Vue.use(Vuex);
Vue.use(VueMask);
Vue.use(Vuelidate);

Vue.use(vuexI18n.plugin, store, {
    moduleName: 'i18n',
    onTranslationNotFound(locale, key) {
        if (store.state.langKeysSearching[key]) {
            return `!${key}!`;
        }
        store.state.langKeysSearching[key] = true;
        // console.warn(`i18n :: Key '${key}' not found for locale '${locale}'`);
        return new Promise((resolve, reject) => {
            store
                .dispatch('setTranslationForKey', {
                    locale: locale,
                    key: key
                })
                .then(() => {
                    if (store.state.i18n.translations[locale][key] === undefined) {
                        resolve(`!${key}!`);
                        store.state.langKeysSearching[key] = false;
                    } else {
                        resolve(store.state.i18n.translations[locale][key]);
                        store.state.langKeysSearching[key] = false;
                    }
                })
                .catch(e => {
                    reject(e);
                });
        });
    }
});

function init() {
    var product = document.querySelector('.vue-product');
    if (product !== null && product !== undefined) {
        const productId = product.getAttribute('data-object-product-id');
        new Vue({
            el: '.vue-product',
            // router,
            store,
            beforeCreate() {
                this.$store.commit('initStore');
            },
            render: h =>
                h(productTemplate, {
                    props: {
                        productId: Number.parseInt(productId)
                    }
                })
        });
    }

    var offerteCart = document.querySelector('.vue-offerte-cart');
    if (offerteCart !== null && offerteCart !== undefined) {
        new Vue({
            el: '.vue-offerte-cart',
            store,
            beforeCreate() {
                this.$store.commit('initStore');
            },
            render: h => h(offerteCartTemplate)
        });
    }

    var offerteSent = document.querySelector('.vue-offerte-sent');
    if (offerteSent !== null && offerteSent !== undefined) {
        new Vue({
            el: '.vue-offerte-sent',
            store,
            render: h => h(offerteCartSentTemplate)
        });
    }

    var offerteBadges = document.querySelectorAll('.vue-offerte-badge');
    for (var i = 0, len = offerteBadges.length; i < len; i++) {
        if (offerteBadges[i] !== null && offerteBadges[i] !== undefined) {
            new Vue({
                el: offerteBadges[i],
                store,
                beforeCreate() {
                    this.$store.commit('initStore');
                },
                render: h => h(offerteBadgeTemplate)
            });
        }
    }
}

export default {
    init
};
